export const getDocumentTypeData = (fields: Array<string>) =>
	fields.map((field, index) => {
		return {
			id: index + 1,
			name: field
		};
	});
